import { render, staticRenderFns } from "./TraderRatioAccounts.vue?vue&type=template&id=534fad5a&scoped=true&"
import script from "./TraderRatioAccounts.vue?vue&type=script&lang=js&"
export * from "./TraderRatioAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534fad5a",
  null
  
)

export default component.exports